// Components==============
import ControlBar, {
    AudioToBePlayedType,
} from 'components/Layout/ControlBar/ControlBar';
import ExerciseBottom from 'components/UI/ExerciseBottom/ExerciseBottom';
import ExerciseWrapper from 'components/UI/ExerciseWrapper/ExerciseWrapper';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { AudioExerciseContext } from 'screens/AudioExercise/AudioExercise';
import { useHomeworkNavigation } from 'utilities/useHomeworkNavigation';
import './AudioTypingExercise.module.scss';
import AnswerBlock from './components/AnswerBlock/AnswerBlock';
import Text from './components/Text/Text';
// =========================

type AudioTypingExerciseType = {
    answer?: Attributes;
    type: string | undefined;
    userAnswers: string[];
    setUserAnswers: React.Dispatch<React.SetStateAction<string[]>>;
    current: number;
    setCurrent: React.Dispatch<React.SetStateAction<number>>;
};

export type ReadAnswerType = string | { file: string } | undefined;

export const AudioTypingExerciseContext = createContext(
    {} as AudioTypingExerciseType
);

export default function AudioTypingExercise() {
    const { exercise, isFinished, setIsFinished, setProgress } = useContext(
        AudioExerciseContext
    );
    const [userAnswers, setUserAnswers] = useState<string[]>([]);
    const { next, current, setCurrent } = useHomeworkNavigation(userAnswers);

    const exercises = exercise?.exercise;
    const exerciseType = exercise?.exercise[0].layout;

    const [answer, setAnswer] = useState(exercises?.[current]?.attributes);
    const [type, setType] = useState(exercises?.[current]?.layout);

    useEffect(() => {
        setAnswer(exercises?.[current]?.attributes);
        setType(exercises?.[current]?.layout);
    }, [current]);

    useEffect(() => {
        console.log(answer);
        if (answer === undefined) setIsFinished(true);
    }, [answer]);

    useEffect(
        () =>
            setProgress({
                total: exercises?.length,
                done: userAnswers?.length,
            }),
        [userAnswers?.length]
    );

    // TODO: Add phoneme
    const textToBeRead = answer?.show_text
        ? answer?.show_text
        : !answer?.klank
        ? answer?.transfer_word
        : undefined;

    let audioToBePlayed: AudioToBePlayedType = answer?.klank
        ? {
              transferWord: answer?.transfer_word,
              klank: answer?.klank,
              type,
          }
        : undefined;

    let readAnswer: ReadAnswerType = answer?.answer;

    // there are a few exerciseTypes where we need to overwrite the default audio behavior. Those exceptions can be added here
    if (exerciseType === 'create_word' && answer?.klank === '') {
        audioToBePlayed = `audio/create_word/${answer?.transfer_word}.mp3`;
    } else if (exerciseType === 'name_sound') {
        readAnswer = {
            file: `/getKlankAudio/${answer?.answer}`,
        };
    }
    //

    return (
        <AudioTypingExerciseContext.Provider
            value={{
                answer,
                type,
                userAnswers,
                setUserAnswers,
                current,
                setCurrent,
            }}
        >
            <ExerciseWrapper padding="1.5em 1.5em">
                {!isFinished && (
                    <div styleName="wrapper">
                        <AnswerBlock
                            text={answer?.show_text}
                            answerText={
                                userAnswers[current]
                                    ? answer?.show_text_finished
                                    : ''
                            }
                        />
                        <Text />
                    </div>
                )}
            </ExerciseWrapper>
            <ExerciseBottom
                controlBar={
                    <>
                        {!isFinished && (
                            <ControlBar
                                exerciseStatus={
                                    userAnswers?.length === exercises?.length
                                        ? 'finished'
                                        : 'started'
                                }
                                next={next}
                                textToBeRead={textToBeRead}
                                audioToBePlayed={audioToBePlayed}
                                readAnswer={readAnswer}
                                canType
                                useToggle
                            />
                        )}
                    </>
                }
            />
        </AudioTypingExerciseContext.Provider>
    );
}
